"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperImpl = void 0;
var wrapper_session_impl_1 = __importDefault(require("./wrapper-session.impl"));
var WrapperImpl = /** @class */ (function () {
    function WrapperImpl(driver) {
        this.driver = driver;
    }
    WrapperImpl.prototype.close = function () {
        return this.driver.close();
    };
    WrapperImpl.prototype.executeQuery = function (query, parameters, config) {
        validateDatabase(config);
        return this.driver.executeQuery(query, parameters, config);
    };
    Object.defineProperty(WrapperImpl.prototype, "executeQueryBookmarkManager", {
        get: function () {
            return this.driver.executeQueryBookmarkManager;
        },
        enumerable: false,
        configurable: true
    });
    WrapperImpl.prototype.verifyConnectivity = function (config) {
        validateDatabase(config);
        return this.driver.verifyConnectivity(config);
    };
    WrapperImpl.prototype.supportsMultiDb = function () {
        return this.driver.supportsMultiDb();
    };
    WrapperImpl.prototype.verifyAuthentication = function (config) {
        validateDatabase(config);
        return this.driver.verifyAuthentication(config);
    };
    WrapperImpl.prototype.supportsSessionAuth = function () {
        return this.driver.supportsSessionAuth();
    };
    WrapperImpl.prototype.supportsUserImpersonation = function () {
        return this.driver.supportsUserImpersonation();
    };
    WrapperImpl.prototype.session = function (config) {
        validateDatabase(config);
        var session = this.driver.session(config);
        return new wrapper_session_impl_1.default(session);
    };
    WrapperImpl.prototype[Symbol.asyncDispose] = function () {
        return this.driver.close();
    };
    return WrapperImpl;
}());
exports.WrapperImpl = WrapperImpl;
function validateDatabase(config) {
    if (config == null || config.database == null || config.database === '') {
        throw new TypeError("database must be a non-empty string, but got ".concat(config === null || config === void 0 ? void 0 : config.database));
    }
}
